module.exports = __webpack_public_path__ + "img/fa-solid-900.5bee5910.svg";